module.exports = __webpack_public_path__ + "img/lut-and-fotobio.b813503f.svg";